import BaseVm from './BaseVm'
import pageDataObject from '../../application/pageDataObject'
import { getIsMobile } from '../../utils/ua'

class FanorakelVm extends BaseVm {
  get fanorakelId() {
    return pageDataObject.get('post.fanorakel_id')
  }

  get src() {
    let urlPrefix = 'http://www.fanorakel.de/votingbox/'
    return getIsMobile()
      ? `${urlPrefix}mobile/Fanorakel_${this.fanorakelId}`
      : `${urlPrefix}Fanorakel_${this.fanorakelId}`
  }
}

export default FanorakelVm



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/FanorakelVm.js